/**
 * @file        src/lib/languages.js
 * @description The ONE list of content languages the admin console offers.
 *
 *              The platform ships English content only. Testimonials used to
 *              offer en / hi / mr in a dropdown, and Blog / Blog Category /
 *              Package / Holiday used a bare free-text <input maxLength={8}>
 *              — so an admin could save `hi`, `mr`, or any 2–8 character
 *              string, for a storefront that has no translation for it. Every
 *              such row is then content nobody can read.
 *
 *              Locked to English here so all five forms agree, and so widening
 *              the set later (when the storefront can actually serve another
 *              language) is a one-line change in ONE file rather than five.
 *              The stored VALUE stays the ISO code ('en') — the column, the
 *              list screens and the storefront all read codes; only the LABEL
 *              is the human word, because "en" in a dropdown told the admin
 *              nothing.
 * @author      Kinetika Labs
 * @created     2026-09-15
 * @changelog
 *   - 2026-09-15 Claude — Initial. Single source for the language picker.
 */

/** ISO code stored in the DB. Every content table's `language` column. */
export const DEFAULT_LANGUAGE = 'en';

/** Options for <Select>. Value = stored code, label = what the admin reads. */
export const LANGUAGE_OPTIONS = [{ value: 'en', label: 'English' }];

/** Human label for a stored code — used by list screens. Unknown codes show as-is. */
export function languageLabel(code) {
  const hit = LANGUAGE_OPTIONS.find((o) => o.value === String(code || '').toLowerCase());
  return hit ? hit.label : (code || '—');
}
